import { speedingsQueryKeys } from "./queryKeys"
import { useSpeedingsQuery } from "./useSpeedingsQueries"

export function useSpeedingsSurveys(params = {}) {
    const url = "surveys/"
    const queryKey = speedingsQueryKeys.surveys(params)

    return useSpeedingsQuery(
        url,
        queryKey,
        params,
    )
}